import { render, staticRenderFns } from "./previewBoxTab.vue?vue&type=template&id=6b85714c&scoped=true"
import script from "./previewBoxTab.vue?vue&type=script&lang=js"
export * from "./previewBoxTab.vue?vue&type=script&lang=js"
import style0 from "./previewBoxTab.vue?vue&type=style&index=0&id=6b85714c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b85714c",
  null
  
)

export default component.exports